// export const SERVER_URL = "http://localhost/SAJ_Info";
 export const SERVER_URL = "https://sbefintech.co.in/SajInfo";